<p-toast></p-toast>
<p-card>
  <div class="flex flex-col items-center gap-4 justify-between h-[60vh] w-[80vw]
           sm:h-[70vh] sm:w-[25vw] p-1 lg:p-4">
    <img alt="OCOP" class="max-w-full h-auto" height="96" ngSrc="./assets/images/ocop_logo.png" priority width="294"/>


    <p class="text-sm text-center break-words leading-relaxed">
      Token enviado para: <span class="font-semibold">{{ email }}</span>
    </p>

    <div class="w-full space-y-2">
      <label class="block text-sm text-gray-700" for="tokenInput">Digite o token</label>
      <input
        [formControl]="tokenCtrl"
        class="w-full p-2 border rounded"
        id="tokenInput" maxlength="255"
        name="token"
        type="text"
        (keydown.enter)="verifyToken()"
      />
    </div>

    <div class="w-full flex flex-col gap-2">
      <button (click)="verifyToken()" class="button-govbr button-govbr--gray w-full">
        <app-icon-entrar-login></app-icon-entrar-login>
        Entrar
      </button>

      <a (click)="onRequestNewToken()"
         class="cursor-pointer text-sm block text-center text-[#0076d6] hover:text-[#0b4778]">
        Enviar token novamente
      </a>
    </div>
  </div>
</p-card>
